var _path, _path2, _path3, _rect, _circle, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3682 9.08447H34.001C31.4213 9.08447 29.3301 11.4165 29.3301 14.2929V87.2096C29.3301 90.086 31.4213 92.4178 34.001 92.4178H71.3682C73.948 92.4178 76.0392 90.086 76.0392 87.2096V14.2929C76.0392 11.4165 73.948 9.08447 71.3682 9.08447Z",
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1212 9.08435H29.754C27.1742 9.08435 25.083 11.4164 25.083 14.2927V87.2095C25.083 90.0859 27.1742 92.4177 29.754 92.4177H67.1212C69.7009 92.4177 71.7921 90.0859 71.7921 87.2095V14.2927C71.7921 11.4164 69.7009 9.08435 67.1212 9.08435Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1296 13.3306H53.7453",
    stroke: "#292B2E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5144,
    y: 43.0547,
    width: 32.3779,
    height: 16.9851,
    rx: 8.49257,
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3996,
    cy: 51.5474,
    r: 8.28424,
    fill: "#BFEBFF",
    stroke: "#292B2E",
    strokeWidth: 0.416667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0223 5.08373C73.3499 2.31415 77.2312 2.14874 78.7896 4.79533L88.2061 20.7871C89.7124 23.3453 87.868 26.5717 84.8992 26.5717H75.2601C73.5051 26.5717 72.5402 24.531 73.6539 23.1746C74.3645 22.3091 74.2616 21.0363 73.4213 20.2961L69.4898 16.8335C68.2006 15.6981 67.8231 13.8441 68.5657 12.295L72.0223 5.08373Z",
    fill: "#292B2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8754 5.56329C72.273 3.14265 75.7669 3.14266 77.1644 5.56329L86.0309 20.9204C87.4284 23.3411 85.6815 26.3669 82.8864 26.3669H65.1535C62.3584 26.3669 60.6114 23.3411 62.009 20.9204L70.8754 5.56329Z",
    fill: "#FFF7D1",
    stroke: "#292B2E",
    strokeWidth: 0.416667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3241 18.7188L72.8394 11.5149C72.7955 10.8628 73.2886 10.2986 73.9407 10.2548C74.5928 10.2109 75.157 10.7041 75.2009 11.3561C75.2043 11.4075 75.2038 11.4649 75.2009 11.5151L74.7162 18.7188C74.6326 19.5824 73.4065 19.5803 73.3241 18.7188Z",
    fill: "#B58741"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0195 22.3032C74.5528 22.3032 74.9852 21.8708 74.9852 21.3375C74.9852 20.8041 74.5528 20.3717 74.0195 20.3717C73.4861 20.3717 73.0537 20.8041 73.0537 21.3375C73.0537 21.8708 73.4861 22.3032 74.0195 22.3032Z",
    fill: "#B58741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModal);
export default __webpack_public_path__ + "static/media/warning_modal.54e3b4674e37b8e79acf898d2c5e50bc.svg";
export { ForwardRef as ReactComponent };